import { Trans } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { PricingText } from 'components/PricingText'
import { WhatBringsYouVariantPALM } from 'pages/index/components/HeroQuiz/components/WhatBringsYouVariantPALM'
import { HP_INNOVATIVE_SWING_I18N_NAMESPACE } from '../i18n'
import styles from './Variant2HPQuiz.module.scss'

export const HPQuiz = () => (
  <>
    <div className='container d-flex align-items-center'>
      <div className='flex-grow-1' style={{ maxWidth: '540px' }}>
        <div className='mc-my-4 mc-text-d1 mc-text--brand mc-text--uppercase mc-text--balance mc-text--center mc-text-sm--left'>
          <Trans
            ns={HP_INNOVATIVE_SWING_I18N_NAMESPACE}
            i18nKey='cinematicHero.title'
          >
            <p />
            <p className='mc-text-color--primary' />
          </Trans>
        </div>
        <div className='mc-my-4 mc-text-h5 mc-text--center mc-text-sm--left mc-text--balance'>
          <Trans
            i18nKey='cinematicHero.subtitle'
            values={{
              classes: getNumberOfInstructors(),
            }}
            ns={HP_INNOVATIVE_SWING_I18N_NAMESPACE}
          >
            <span />
            <span className='mc-opacity--hinted' />
          </Trans>
          <p className='mc-mt-1'>
            <PricingText translationKey='short' />
          </p>
        </div>
        <div className={styles.quizWrapper}>
          <WhatBringsYouVariantPALM />
        </div>
      </div>
    </div>
  </>
)
